import React from "react";
import { orders } from "../../utils/order";
import { Button } from "@mui/material";
import { BiListCheck } from "react-icons/bi";
import useWindowWidth from "../../hooks/useWindowWidth";
import useWindowHeight from "../../hooks/useWindowHeight";

export default function FulFillOrderCarouselComponent() {
  const windowWidth = useWindowWidth()
  const windowHeight = useWindowHeight()
  return (
    <div style={{ padding: "0px 20px", boxSizing:"border-box" }}>
      <div style={{ textAlign: "center", color: "white" }}>
        <h4 style={{  fontSize: windowHeight <= 745 ? "20px" :windowWidth <=1500 ? "22px" :"30px" }}>Manage your order fulfillment</h4>
        <h6 style={{ fontSize: windowHeight <= 745 ? "12px": windowWidth <=1500 ? "14px" : "16px" }}>
          A simple and clear way to process all your
        </h6>
        <h6 style={{ fontSize:  windowHeight <= 745 ? "12px": windowWidth <=1500 ? "14px" : "16px" }}>
          Orders at once. Don't lose track of anything.
        </h6>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: windowWidth <=1392  ? "10px auto":"20px auto",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems:"center",
              margin: "10px 0px 10px 0px",
              background: "#D3C8EE",
              padding: "10px 12px",
              borderRadius: "10px",
            }}
          >
            <BiListCheck size={22} color="#9562F4" />
            <b style={{ color: "#9562F4", fontSize: "14px" }}>Fulfill</b>
          </div>
        </div>
      </div>

      {orders.map((order) => (
        <div
          key={order.id}
          style={{
            background: "#fff",
            borderRadius: "20px",
            padding: "8px 20px",
            marginBottom: "10px",
          }}
        >
          <div className="flexbox">
            <h5 style={{ fontSize: windowHeight <= 745 ? "12px":windowWidth <=1392 ? "14px": "16px" }}>{order.orderNumber}</h5>
            <h5 style={{ fontSize: windowHeight <= 745 ? "12px":windowWidth <=1392 ? "14px": "16px" }}>{order.name}</h5>
            <Button
              variant="deepbluemini"
              //   onClick={handleOpen}
              sx={{
                background: "#8D40FF",
                color: "#fff",
                fontSize: windowWidth <=1392 ? "11px":"12px",
                padding: windowWidth <=1392 ? "8px 14px" :windowHeight <= 745 ? "5px 14px": "11px 14px",
                width: "auto",
                margin: 0,
                height: "auto",
                ":hover": {
                  background: "8D40FF",
                },
                boxShadow: "none",
                pointerEvents: "none",
              }}
            >
              Fulfill order
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
